// extracted by mini-css-extract-plugin
export var errorsContainer = "_uu-1";
export var link = "_uu-0";